module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg13.f01f11e7.jpg";